import React, { Fragment } from "react";

const Link = ({
    value,
    onClick
}) => {

    if(!value){
        return "-"
    }

    return (
        <span className="rt--link" onClick={onClick}>{value}</span>
    );
}

export default Link;